import React from "react"

export default function Component({ className = "", style = {} } = {}) {
  const className_ = className
  const style_ = style
  return ({ className = "", style = {}, children, ...props }) => (
    <div
      className={`${className} ${className_}`}
      style={{ ...style_, ...style }}
      {...props}
    >
      {children}
    </div>
  )
}
